import { Routes, Route, Navigate } from "react-router-dom";
import {EcomSolution, PackNGO, TcsAir, TcsCare, CoolControl, Fashion, Fresh, Hazir, Warehouse} from './../../../helpers/modules'
import Octara from "./Octara";
import Yayvo from "./Yayvo";


const supplyChainRoutes = [
    {routeName: 'pack-n-go' , component: <PackNGO/>},
    {routeName: 'tcs-air' , component: <TcsAir/>},
    {routeName: 'tcs-cares' , component: <TcsCare/>},
    {routeName: 'tcs-cool-control' , component: <CoolControl/>},
    {routeName: 'tcs-fashion' , component: <Fashion/>},
    {routeName: 'tcs-fresh' , component: <Fresh/>},
    {routeName: 'tcs-hazir' , component: <Hazir/>},
    {routeName: 'warehousing' , component: <Warehouse/>},
    {routeName: 'ecom-solutions' , component: <EcomSolution/>},
    {routeName: 'yayvo' , component: <Yayvo/>},
    {routeName: 'octara' , component: <Octara/>},
];

const SupplyRoutes = () => {
    return (
    <Routes>
       {supplyChainRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default SupplyRoutes;